const ApiUrl1 = 'https://student.tdtu.uz/rest/v1/';

export {ApiUrl1}